import type { HistoryEntry } from '../../../types/calculator';

export const calculatorHistoryHeaders = [
  'timestamp',
  'peptide_name',
  'vial_amount',
  'vial_units',
  'dosage',
  'dosage_units',
  'target_syringe_units',
  'reconstitution_amount',
  'reconstitution_units',
  'final_concentration',
  'units_per_dose',
  'dose_milliliters',
  'total_doses'
] as const;

export const toCSV = (entry: HistoryEntry): Record<string, string> => ({
  timestamp: new Date(entry.timestamp).toISOString(),
  peptide_name: entry.inputs.peptideName,
  vial_amount: entry.inputs.vialAmount.toString(),
  vial_units: entry.inputs.vialUnits,
  dosage: entry.inputs.dosage.toString(),
  dosage_units: entry.inputs.dosageUnits,
  target_syringe_units: entry.inputs.targetSyringeUnits.toString(),
  reconstitution_amount: entry.metrics.reconstitutionAmount.toString(),
  reconstitution_units: entry.metrics.reconstitutionUnits,
  final_concentration: entry.metrics.finalConcentration.toString(),
  units_per_dose: entry.metrics.unitsPerDose.toString(),
  dose_milliliters: entry.metrics.doseMilliliters.toString(),
  total_doses: entry.metrics.totalDoses.toString()
});

export const fromCSV = (row: Record<string, string>): Partial<HistoryEntry> => ({
  timestamp: new Date(row.timestamp).getTime(),
  inputs: {
    peptideName: row.peptide_name as any,
    vialAmount: Number(row.vial_amount),
    vialUnits: row.vial_units as any,
    dosage: Number(row.dosage),
    dosageUnits: row.dosage_units as any,
    targetSyringeUnits: Number(row.target_syringe_units)
  },
  metrics: {
    reconstitutionAmount: Number(row.reconstitution_amount),
    reconstitutionUnits: row.reconstitution_units,
    finalConcentration: Number(row.final_concentration),
    unitsPerDose: Number(row.units_per_dose),
    doseMilliliters: Number(row.dose_milliliters),
    totalDoses: Number(row.total_doses)
  }
});